import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import nextSVG from '../assets/next.svg';
import likeSVG from '../assets/like.svg';
import '../styles/swiper.min.css';
import '../styles/customSwiper.css';

import TextOverlay from './textOverlay';

SwiperCore.use([Pagination]);

const reviews = [
  {
    id: 1,
    review: `Работать со Светланой было одним удовольствием. Полное сопровождение, грамотные юридические консультации на каждом шагу и железное спокойствие. Весь процесс продажи прошел вообще без нашего участия и нервотрепки, оперативно вышли на сделку. Высококлассный специалист и очень надежный человек. Спасибо!`,
    author: 'Сергей, 4 сентября 2026 года',
  },
  {
    id: 2,
    review: `Сработали со Светланой на отлично. Никакой лишней воды, всё строго по делу и в рамках закона. Очень подкована в юридических вопросах, сразу чувствуешь себя в безопасности как клиент. Все этапы прошли гладко и без задержек. Если ищете надежного риэлтера в Минске, обращайтесь к ней, не пожалеете!`,
    author: 'Светлана, 3 сентября 2026 года',
  },
  {
    id: 3,
    review: `Светлана — риэлтер от бога! Процесс, который казался нам тёмным лесом, она провела легко и понятно. Законы знает идеально, на связи 24/7, все документы подготовила моментально. Покупателя нашли быстро, сделку закрыли без сучка и задоринки. Огромное человеческое спасибо за такой крутой результат!`,
    author: 'Михаил, 3 сентября 2026 года',
  },
  {
    id: 4,
    review: `Добрый день, хочу рассказать свою историю. Сначала решил сделать все сам, без риэлтера. Пожалел об этом очень быстро, когда стало понятно, что в документах на квартиру есть нюансы. Привлек Светлану. Спасибо, что она согласилась, проверила все документы, организовала расчеты. Один эту напругу бы не сдюжил.`,
    author: 'Дмитрий, 2 сентября 2026 года',
  },
  {
    id: 5,
    review: `Повторно обратились к Светлане спустя несколько лет для покупки квартиры. Очень приятный, профессиональный, интеллигентный и доброжелательный риэлтер. Всем рекомендую. Чувствуешь себя намного спокойнее и защищеннее, когда рядом Светлана.`,
    author: 'Анна, 1 сентября 2026 года',
  },
  {
    id: 6,
    review: `Огромное спасибо Светлане за её работу! С первой минуты общения поняли, что имеем дело с профессионалом. Человек досконально знает законодательство, оперативно решает любые возникающие вопросы и искренне отстаивает интересы клиента. Сделка прошла легко и максимально прозрачно. Рекомендую от души!`,
    author: 'Егор, 1 сентября 2026 года',
  },
  {
    id: 7,
    review: `Светлана просто спасла наше время и нервы! Нужно было срочно решить вопрос с недвижимостью в Минске, и она справилась на ура. Всё юридически безупречно, без лишней беготни и пустых разговоров. Очень грамотный, честный и приятный в общении специалист. Теперь по всем жилищным вопросам — только к ней!`,
    author: 'Катя, 1 сентября 2026 года',
  },
  {
    id: 8,
    review: `Обращались к Светлане за консультацией по недвижимости и остались в полном восторге. Она разложила всё по полочкам, ответила на сложные вопросы и показала блестящее знание законов. Сразу виден огромный опыт и профессионализм. После общения не осталось никаких сомнений, как действовать дальше. Огромное спасибо за помощь!`,
    author: 'Ирина, 30 августа 2026 года',
  },
  {
    id: 9,
    review: `Хочу поблагодарить Светлану за проведение сложнейшей сделки по обмену квартир. Была длинная цепочка из нескольких продавцов и покупателей, но Светлана справилась идеально. Всё было организовано четко, юридически грамотно и очень быстро. Настоящий мастер своего дела, которому можно доверять на все 100%!`,
    author: 'Вадим Игоревич, 30 августа 2026 года',
  },
  {
    id: 10,
    review: `Светлана — отличный риэлтер и мастер своего дела. Сразу видно юридическую подкованность и огромный опыт. Помогла оперативно найти покупателя и за пару дней оформить все документы для продажи. Всё четко, честно и по делу. Огромная благодарность за результат!`,
    author: 'Алексей, 29 августа 2026 года',
  },
]

const ReviewText = props => (
  <p {...props} />
)

const Author = props => (
  <div
    className="flex font-bold mt-50px justify-end"
  >
    <div {...props} />
  </div>
);

const Slider = () => {
  const swiperRef = useRef(null);
  const reviewsJsx = reviews.map(({ id, review, author }) => (
    <SwiperSlide className="relative rounded-20px bg-white swiper-shadow w-286px h-605px md:w-630px md:h-420px px-50px py-130px" key={id}>
      <div 
        className="absolute -top-35px"
        style={{
          left: "calc(50% - 45px)"
        }}
      >
        <div
          className="absolute -left-30px -top-35px rounded-20px w-150px h-150px"
          style={{
            background: '#FAF5FF',
            transform: 'rotate(12.47deg)',
          }} />
        <img
          alt=""
          src={likeSVG}
          className="relative w-80px h-80px z-10"
        />
      </div>
      <ReviewText className="text-16px font-light">{review}</ReviewText>
      <Author>{author}</Author>
    </SwiperSlide>
  ));
  return (
    <div className="relative">
      <div className="flex items-center my-8 px-0px sm:px-17px bg-white mx-0px lg:mx-130px">
        <button onClick={() => swiperRef.current.swiper.slidePrev()}>
          <img
            className="w-35px h-35px hidden lg:block absolute left-0 cursor-pointer"
            src={nextSVG}
            alt="Предыдущий слайд"
          />
        </button>
        <div
          className="-m-30px p-30px overflow-hidden pt-100px"
          style={{
            width: 'calc(100% + 60px)',
            height: 'calc(100% + 60px)',
          }}
        >
          <Swiper
            spaceBetween={50}
            breakpoints={{
              320: {
                slidesPerView: 1,
              },
              1280: {
                slidesPerView: 2,
              }
            }}
            slidesPerView={2}
            ref={swiperRef}
            loop
            pagination={{
              el: '.swiper-pagination',
              clickable: true,
              renderBullet: (index, className) => `<span class="${className} m-2 cursor-pointer w-10px h-10px border border-danger rounded-full"></span>`,
            }}
          >
            {reviewsJsx}
          </Swiper>
        </div>
        <button onClick={() => swiperRef.current.swiper.slideNext()}>
          <img
            className="w-35px h-35px hidden lg:block transform rotate-180 absolute right-0 cursor-pointer"
            src={nextSVG}
            alt="Следующий слайд"
          />
        </button>
      </div>
      <div className="swiper-pagination flex justify-center" />
    </div>
  )
}

const Reviews = () => (
  <div className="mt-60px">
    <TextOverlay name="reviews" text="Отзывы клиентов" />
    <div className="container">
      <Slider />
      <div className="flex flex-col items-center px-17px">
        <div className="font-light font-16px my-10">
          Буду рада, если ваш отзыв будет следующим. Все отзывы  вы можете почитать здесь
        </div>
        <a
          className="p-4 rounded-20px border border-danger text-danger"
          href="https://m.realt.by/realtors/person/325034/"
        >Отзывы на realt.by</a>
      </div>
    </div>
  </div>
);

export default Reviews;
